<template>
	<div class="rem:max-w-[488px] max-md:mx-auto">
		<h2 class="typo-h2 text-left text-heading-primary mb-2">
			Popis produktu
		</h2>
		<p class="mb-4 text-body-secondary typo-body-s" v-html="product.description" />
		<ProductAccordion v-if="product.contains && product.contains.length" title="Složení">
			<p class="text-body-secondary typo-body-s" v-html="product.contains" />
		</ProductAccordion>
		<ProductAccordion v-if="product.allergens && product.allergens.length" title="Alergeny">
			<p
				class="text-body-secondary typo-body-s"
				v-html="product.allergens[0].name"
			/>
		</ProductAccordion>
		<ProductAccordion v-if="product.storage && product.storage.length" title="Skladování">
			<p class="text-body-secondary typo-body-s" v-html="product.storage" />
		</ProductAccordion>
		<ProductAccordion
			v-if="product.nutritionValues && product.nutritionValues.length"
			title="Nutriční hodnoty"
		>
			<table class="w-full text-body-secondary typo-body-s">
				<tbody>
					<tr v-for="(value, key) in product.nutritionValues" :key="key">
						<template v-if="value.title">
							<td>
								{{ getNutritionValueTitle(value.title) }}
							</td>
							<td class="text-right">
								{{ value.value }}
							</td>
						</template>
					</tr>
				</tbody>
			</table>
		</ProductAccordion>
		<div v-if="!hidePriceValidity" class="mt-12 typo-body-s text-body-secondary">
			Zobrazená cena produktu je platná na prodejně k
			{{ format(new Date(), 'dd. MM. yyyy HH:mm') }} a v průběhu dne se může měnit.
		</div>
	</div>
</template>

<script setup lang="ts">
	import {format} from 'date-fns';
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';
	import {NutritionValues} from '@/types/product';

	type Props = {
		product: ProductDetail;
		hidePriceValidity?: boolean;
	};

	defineProps<Props>();

	function getNutritionValueTitle(key?: string): string {
		return NutritionValues[key as keyof typeof NutritionValues] ?? '';
	}
</script>
